import { ComponentPropsWithoutRef } from 'react';

import { TContractCancellationStatus } from 'modules/customer/domain/entities';
import { ContractTag } from 'modules/customer/presentation/components/atoms';
import { ITheme } from 'shared/presentation/contexts';

type TContractCancellationTagParams = {
  theme: ITheme;
  tracking: { statusDescription: string };
};

type TContractTagProps = ComponentPropsWithoutRef<typeof ContractTag>;

const neutralTag = ({
  theme,
  tracking,
}: TContractCancellationTagParams): TContractTagProps => ({
  color: theme.palette.neutral[500],
  children: tracking.statusDescription,
});

const attentionTag = ({
  theme,
  tracking,
}: TContractCancellationTagParams): TContractTagProps => ({
  color: theme.palette.warning.dark,
  children: tracking.statusDescription,
});

export const CONTRACT_CANCELLATION_TAGS: Record<
  TContractCancellationStatus,
  (params: TContractCancellationTagParams) => TContractTagProps
> = {
  UNDER_REVIEW: neutralTag,
  AWAITING_SIGNATURE: attentionTag,
  SIGNATURE_LINK_EXPIRED: attentionTag,
  COMPLETED: ({ theme, tracking }) => ({
    color: theme.palette.primary.main,
    children: tracking.statusDescription,
  }),
  NOT_APPROVED: ({ theme, tracking }) => ({
    color: theme.palette.error.main,
    children: tracking.statusDescription,
  }),
  CLOSED_WITHOUT_EFFECT: neutralTag,
};
